(($) => {

    'use strict'

	// ----------------------------------------------------------------------------------------------------

    $(document).ready(() => {
        window.dispatchEvent(new Event('resize'))
    })

    // ----------------------------------------------------------------------------------------------------

    $('li.slide-out-widget-area-toggle > div > a')
        .addClass('closed hamburger hamburger--3dy')
        .empty()
        .append('<span class="hamburger-box"><span class="hamburger-inner"></span></span>')
        .click(function() {

            if($('#slide-out-widget-area-bg').hasClass('hidden')){
                $(this).addClass('is-active')
            }

            if($('#slide-out-widget-area-bg').hasClass('open')){
                $(this).removeClass('is-active')
            }

        });

    // Equal height for offer tiles
    // ----------------------------------------------------------------------------------------------------
    function sameWidth () {

        $('.same-width-wrapper').each((index, el) => {

            var allItemWidth = 0
            var wrapper = $(el)
            var items = wrapper.find('.same-width-item')

            items.each((index, el) => {
                var item = $(el)
                item.css({'width' : ''})
            })

            items.each((index, el) => {
                var item = $(el)
                if (item.width() > allItemWidth) { 
                    allItemWidth = item.width()
                }
            })

            items.each((index, el) => {
                var item = $(el)
                item.width(allItemWidth)
            })
            
        })

    }

    sameWidth()

    $( window ).resize(function() {
        sameWidth()
    });


    // Categories of the advanced search
    // ----------------------------------------------------------------------------------------------------

    $('.advanced-search-wrapper > .open-close-button').click(function(event) {
        $('.advanced-search-wrapper > .advanced-search').toggle()
        sameWidth()
    })

    $('.search-result-order-wrapper > .open-close-button').click(function(event) {
        $('.search-result-order-wrapper > .search-result-order').toggle()
        sameWidth()
    })

    $('.categories .item').each(function(){

        var label    = $(this)
        var inColor  = label.data('color')
        var outColor = label.css("color")

        // Get the button state
        if(label.hasClass('selected')){

            label.css({
                'color': inColor,
                'border-color': inColor,
            })

            label.find('input').prop('checked', true)

        }

        // Hover events
        label.hover(function() {

            if(!label.hasClass('selected')){
                label.css({
                    'color': inColor,
                    'border-color': inColor,
                })
            }

        }, function() {

            if(!label.hasClass('selected')){
                label.css({
                    'color': outColor,
                    'border-color': outColor,
                })
            }

        })

        // Click events
        label.click(function(){

            if(label.hasClass('selected')){

                label.removeClass('selected')
                label.css({
                    'color': outColor,
                    'border-color': outColor,
                })

                label.find('input').prop('checked', false)

            } else {

                label.addClass('selected')
                label.css({
                    'color': inColor,
                    'border-color': inColor,
                })

                label.find('input').prop('checked', true)

            }

        })

    })

    // Do not send empty values in advanced search form
    // ----------------------------------------------------------------------------------------------------

        $('form#search').submit(function () {
            $(this)
                .find('#advanced-search-city')
                .filter(function () {
                    return !this.value
                })
                .prop('name', '')
        })


})(jQuery)